<template>
  <div class="content">
    <h1 class="content__title">Navegador de imágenes</h1>
    <span class="content__details">Sube tus imágenes al servidor antes de utilizarlas, luego agregalas a tu publicacion, galería, o cualquier otros lugar.</span>
    <div class="content__container">
      <main class="main">
        <section class="main__section main__section--relative">
          <media-images></media-images>
        </section>
      </main>
    </div>
  </div>
</template>

<script>
import mediaImages from '@/components/media/browser'
export default {
  components: {mediaImages}
}
</script>



// WEBPACK FOOTER //
// src/components/media/viewer.vue